import Loader from '@/shared/components/Loader';
import { useWavesurferPlayback } from '@/shared/audio/useWavesurferPlayback'

const Playback = ({ playbackAudioUrl, muted, playBackState = "pause", onPlaybackStateChange }) => {
  const { containerRef, isLoading, loadError } = useWavesurferPlayback({
    playbackAudioUrl,
    muted,
    playBackState,
    onPlaybackStateChange,
  });

  return (
    <div className="w-full relative">
      <div className="wave-container">
        <div ref={containerRef} className={isLoading ? 'opacity-0' : 'opacity-100 transition-opacity duration-300'} />
      </div>
      
      {isLoading && !loadError && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-50/50">
          <div className="flex flex-col items-center space-y-2">
            <Loader />
          </div>
        </div>
      )}
      {loadError && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-50/80 px-2 text-center text-xs text-gray-600">
          Preview unavailable
        </div>
      )}
    </div>
  )
}

export default Playback
